var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.saleLabelObj)?_c('div',{staticClass:"i-tips",class:_vm.saleLabelObj && _vm.saleLabelObj.class,attrs:{"label":_vm.saleLabelObj && _vm.saleLabelObj.label}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }